import React, { useState, useEffect, useMemo } from "react";
import { Container } from "./styles";

import Table from "components/table";
import ActionPanel from "./actionPanel";
import { useHeader } from "components/header/store";
import { instanceAPI } from "api";
import { getTaskData } from "api/taskStatus";

const DEFAULT_VISIBLE_COLUMNS = [
  "name",
  "power",
  "connect",
  "login",
  "owner",
  "ou",
  "cpu",
  "ram",
  "disk",
  "vgpu",
  "ip",
  "internet",
  "anyware_users",
];

const tags = [
  { name: "name", type: "text", width: "20px" },
  { name: "power", type: "power", width: "5px" },
  { name: "kind", type: "text", width: "9px" },
  { name: "connect", type: "power", width: "5px" },
  { name: "login", type: "text", width: "8px" },
  { name: "owner", type: "text", width: "8px" },
  { name: "ou", type: "text", width: "10px" },
  { name: "cpu", type: "text", width: "4px" },
  { name: "ram", type: "text", width: "4px" },
  { name: "disk", type: "text", width: "5px" },
  { name: "vgpu", type: "text", width: "4px" },
  { name: "vgpu_pci", type: "text", width: "4px" },
  { name: "network", type: "text", width: "4px" },
  { name: "ip", type: "text", width: "15px" },
  { name: "internet", type: "power", width: "5px" },
  { name: "os", type: "text", width: "20px" },
  { name: "anyware_users", type: "text", width: "20px" },
  { name: "hypervisor", type: "text", width: "20px" },
  { name: "hostsystem", type: "text", width: "20px" },
];

const InstancePage = () => {
  const [instances, setInstances] = useState<any[]>([]);
  const [selectInstances, setSelectInstances] = useState<any[]>([]);
  const [filterData, setFilterData] = useState<Record<string, boolean>>({});
  const [isLoading, setIsLoading] = useState(false);

  const { setTitle, setButtons } = useHeader();

  /** ✅ 필터 초기값은 tags 기준으로 딱 1번 */
  useEffect(() => {
    const initialFilter: Record<string, boolean> = {};
    tags.forEach((col) => {
      initialFilter[col.name] = DEFAULT_VISIBLE_COLUMNS.includes(col.name);
    });
    setFilterData(initialFilter);
  }, []);

  /** Header ActionPanel */
  useEffect(() => {
    setTitle("INSTANCE");
    setButtons(
      <ActionPanel
        instanceLen={instances.length}
        selectInstance={selectInstances}
        filterData={filterData}
        setFilterData={setFilterData}
      />
    );
  }, [setTitle, setButtons, instances.length, selectInstances, filterData]);

  /** 데이터 로딩 */
  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);

      const instanceList = (await getTaskData(instanceAPI.getInstnaceList))
        .result.data;

      const result = await Promise.all(
        instanceList.map((inst) =>
          getTaskData(() => instanceAPI.getInstance(inst)).then((r) => {
            const item = r.result.data;
            return {
              name: item.name,
              power: item?.power === "ON",
              kind: item.kind,
              connect: item?.session === "connect",
              login: item.login,
              owner: item.owner,
              ou: item.ou,
              cpu: item.cpu,
              ram: item.ram,
              disk: item.disk,
              vgpu: item.vgpu,
              vgpu_pci: item.vgpu_pci,
              network: item.network,
              ip: item.ip,
              internet: item.internet,
              os: item.os,
              anyware_users: item.anyware_users,
              hypervisor: item.hypervisor,
              hostsystem: item.hostsystem,
            };
          })
        )
      );

      setInstances(result);
      setIsLoading(false);
    };

    fetchData();
  }, []);

  const visibleTags = useMemo(() => {
    return tags.filter((col) => filterData[col.name]);
  }, [filterData]);

  return (
    <Container>
      <Table
        tags={visibleTags}
        data={instances}
        isCheck
        setCheckData={setSelectInstances}
        loading={isLoading}
      />
    </Container>
  );
};

export default InstancePage;
